var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"hm-reload-btn",class:{ 'hm-reload-btn--active': _vm.model, 'hm-reload-btn--disabled': _vm.isDisabled },attrs:{"type":"button","disabled":_vm.isDisabled},on:{"click":_vm.onClick}},[_c('span',{staticClass:"hm-reload-btn__spinner"})])
}
var staticRenderFns = []

export { render, staticRenderFns }